import { useEffect } from 'react';

import { MessageBus } from '@app-velocity/message-bus';

import { useConfigStore } from '../../stores/useConfigStore';

const messageBus = new MessageBus('system');

export const VersionControl = () => {
    const versionChange = useConfigStore((state) => state.isAppVersionChanged());

    useEffect(() => {
        if (versionChange !== 'major') return;

        messageBus.publish('modal:version:open');
    }, [versionChange]);

    return null;
}